import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { db } from "../../../lib/firebase";
import { useFirestoreDocOnce } from "../../../hooks/useFirestoreDocOnce";
import { LocationForm } from "./LocationForm";
import { Collections, type EventLocation } from "@event-planner/shared";

export function LocationEditPage() {
  const { locationId } = useParams<{ locationId: string }>();

  const docRef = useMemo(
    () =>
      locationId ? doc(db, Collections.EVENT_LOCATIONS, locationId) : null,
    [locationId],
  );
  const { data: location, loading } =
    useFirestoreDocOnce<EventLocation>(docRef);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!location) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography variant="h5" component="h1">
          Location not found
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          This location may have been deleted.
        </Typography>
      </Box>
    );
  }

  return <LocationForm mode="edit" initialData={location} />;
}
